import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';

interface IPayload {
  customerId: string;
  linkedAccountId: string;
  accountType: string;
}

export const useSetAccountTypeMutation = (onError: (data: any)=> void) => useMutation(
  'accountType',
  async ({ customerId, linkedAccountId, accountType }: IPayload) => {
    const { data } = await httpService.post(`/api/v1/user/${customerId}/account/${linkedAccountId}`, {
      accountType,
    });
    return data;
  },
  {
    onError: (e: any) => {
      console.error(e);
      onError(e.response.data.errors[0]);
    },
  },
);
